import React, { useState } from "react";
import { useAppSelector } from "../../../../../store/types";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import SbuxStyledTableCell from "../../../../../components/SbuxTable/SbuxStyledTableCell";
import SbuxStyledTableRow from "../../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxTranslate from "../../../../../components/SbuxTranslate";
import SbuxDialog2 from "../../../../../components/SbuxDialog2";

import styles from "../../styles";
import useCss from "../../../../../hooks/useCss";
import { StyledDeleteButton } from "../../styled";
import { getConnectStatusSelector } from "../../../../../selectors/connectSelector";

interface Props {
  row: Record<string, unknown>;
  handleDeleteRowClick: (row: Record<string, unknown>) => void;
}

const RowSource = ({ row, handleDeleteRowClick }: Props) => {
  const status = useAppSelector(getConnectStatusSelector);
  const [openConfirmDialog, setOpenConfigDialog] = useState(false);
  const classes = useCss(styles);

  const toggleDialogOpen = () => {
    setOpenConfigDialog(!openConfirmDialog);
  };

  const handleOnClickDeleteEvent = () => {
    if (!status.endsWith("pending")) {
      setOpenConfigDialog(true);
    }
  };

  const dialogConfig = {
    title: "Confirm",
    hasBackdrop: false,
    asModal: true,
  };

  return (
    <>
      <SbuxStyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <SbuxStyledTableCell className={classes.cellFocus}>
          {row["Name"] as React.ReactNode}
        </SbuxStyledTableCell>

        <SbuxStyledTableCell>
          <StyledDeleteButton
            onClick={handleOnClickDeleteEvent}
            disableFocusRipple
            disableRipple
          />
        </SbuxStyledTableCell>
      </SbuxStyledTableRow>

      {openConfirmDialog && (
        <SbuxDialog2
          open={openConfirmDialog}
          config={dialogConfig}
          handleOnClose={toggleDialogOpen}
        >
          <DialogContent dividers>
            <Typography variant="h5">
              <SbuxTranslate>{`Are you sure you want to delete `}</SbuxTranslate>
              <span>{`${String(row["Name"])}?`}</span>
            </Typography>
          </DialogContent>

          <DialogActions>
            <Box className="actionContainer">
              <Button
                variant="contained"
                size="medium"
                onClick={() => {
                  handleDeleteRowClick(row);
                  setOpenConfigDialog(false);
                }}
              >
                Okay
              </Button>
              <Button
                variant="outlined"
                size="medium"
                onClick={() => {
                  setOpenConfigDialog(false);
                }}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </SbuxDialog2>
      )}
    </>
  );
};

export default RowSource;
